export const userAuth = {
  AUTH: 1,
  ACCESS_MISSION: 2,
  MISSION_UPDATE_HEADER: 3,
  MISSION_UPDATE_REPORT: 4,
  MISSION_ASSIGN: 5,
  REPORT_CONSULT: 6,
  REPORT_VALIDATE: 7,
  REPORT_CONSULT_EXTERNAL: 8,
  MISSION_FEEDBACK_UPDATE: 9,
  MISSION_FEEDBACK: 10,
  DEVICE_REGISTER: 11,
  ADD_OPERATOR: 12,
  GET_REFERENTIAL: 13,
  MANAGE_COMMITMENT: 14,
  MISSION_CANCEL: 15,
  MISSION_SEND: 16,
  MAP_ACCESS: 17,
  MEDIA_ACCESS: 18,
  HISTORY_ACCESS: 19,
  MANAGE_CACHE: 20,
  AP_REGULATION: 21,
  MISSION_SP_SENDING: 22,
  MISSION_OPE_SMUR: 23,
  MISSION_OPE_AP: 24,
  MISSION_OPE_SP: 25,
  MISSION_ORIG_SAMU: 26,
  MISSION_ORIG_EHPAD: 27,
  MISSION_ORIG_GP: 28,
  SAED_ACCESS: 29,
  MISSION_OPE_EXT: 30,
  LIVE_VIDEO: 31,
  NOTIF_ACCESS: 32,
  ADMIN_CENTER: 33,
  BISOM_ADMIN: 34,
  MISSION_ORIG_TABLET: 35,
  VIDEO_LIVE_MISSION: 36,
  MISSION_ASSIGN_TEAM: 37,
  ARM_MANAGE_OPERATOR: 38,
  AP_LEGAL: 39,
  DASHBOARD: 40,
  EXT_VEHICLE: 41,
  EXT_EVA: 42,
  AP_BILLING: 43,
  REPORTING_ACCESS: 44,
  AP_WATCH: 45,
  MISSION_ORIG_EMERGENCY: 46,
  ARCHIVING: 49,
  ARCHIVE_CREATE: 50,
  ADMIN_REGION: 51,
  PATIENT_IDENTITY_UPDATE: 62,
  ATSU: 66,
  MISSION_OTHER_SENDING: 69,
  MISSION_MANUAL_CLOSE: 71,
  MISSION_SHORTAGE: 72,
};

export const jobScope = {
  SMUR_SAMU: "SMUR_SAMU",
  SAMU: "SAMU",
  AP: "AP",
  SMUR: "SMUR",
  SP: "SP",
  EHPAD: "EHPAD",
  PDS: "PDS",
  ARM: "ARM",
  CH: "CH",
  ATSU: "ATSU",
};

export const reportingAuthType = {
  USER: 7,
};

export const userFunctionAuth = {
  DOCTOR: 1,
  INTERNE: 6,
};

export const organizationAuth = {
  ALLOWED_UPDATE_MISSION_DAYS: "ALLOWED_UPDATE_MISSION_DAYS" as const,
  CREATE_MISSION: "CREATE_MISSION" as const,
  LRM: "LRM" as const,
  MAP: "MAP" as const,
  SEND_REPORT: "SEND_REPORT" as const,
  LRM_TEAM_SYNCHRO: "LRM_TEAM_SYNCHRO" as const,
  VIDEO_REGUL: "VIDEO_REGUL" as const,
  LRM_SCAN: "LRM_SCAN" as const,
  VECTOR_FILTER: "VECTOR_FILTER" as const,
};
